import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as g, S as f } from "./icons.types-0722eef5.js";
function m({ title: h, titleId: n, size: i, width: o, height: t, extended: s = !1, ...c }) {
  const r = s ? g : f, a = i ? r[i] : o || r[s ? "s" : "l"], e = i ? r[i] : t || r[s ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: a,
      height: e,
      "aria-labelledby": n,
      ...c,
      children: [
        h ? /* @__PURE__ */ l("title", { id: n, children: h }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#X_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M42.852 30.472 69.654 0H63.3L40.026 26.459 21.438 0H0l28.11 40.008L0 71.965h6.354L30.93 44.02l19.632 27.944H72L42.852 30.472Zm-8.7 9.888-2.85-3.984L8.64 4.676h9.756l18.288 25.585 2.85 3.985 23.772 33.253H53.55L34.152 40.36Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "X_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  m as X
};
